import type {
    ListDashboardsResponse,
    Dashboard,
    SearchDashboardsRequest,
    SearchWidgetRequest, NewDashboard, Widget, CountDashboardsRequest, CopyDashboardRequest
} from '../types/dashboards';
import { APIClient, buildQueryParamsString } from 'vince-core/api/apiClient';
import { getBaseUrl } from 'vince-core/utils/env';

const baseUrl = getBaseUrl('/v1/dashboards');


export async function loadDashboards (query?: SearchDashboardsRequest) {
    const q = clone(query) as Record<string, string | undefined>;
    if (q) {
        q.sortDirection = q?.sortDirection?.toUpperCase() || undefined;
    }
    return await APIClient<ListDashboardsResponse>(`${baseUrl}/${buildQueryParamsString(q)}`);
}

export async function getDashboardsCount (query?: CountDashboardsRequest): Promise<ListDashboardsResponse> {
    const q = clone(query) as Record<string, string | undefined>;
    if (q) {
        q.sortDirection = q?.sortDirection?.toUpperCase() || undefined;
    }
    return await APIClient<ListDashboardsResponse>(`${baseUrl}/count${buildQueryParamsString(q)}`);
}

export async function copyDashboard (dashboardId: string, dashboard: CopyDashboardRequest) {
    return await APIClient<Dashboard>(`${baseUrl}/${dashboardId}/copy`, { method: 'POST', body: JSON.stringify(dashboard) });
}

export async function loadDashboard (id: string, query?: SearchWidgetRequest) {
    return await APIClient<Dashboard>(`${baseUrl}/${id}${buildQueryParamsString(query)}`);
}

export async function saveDashboard (dashboard: NewDashboard | Dashboard) {
    const payload = clone(dashboard);
    if ('dashboardId' in payload) {
        return await updateDashboardDetail(dashboard);
    } else {
        return await APIClient<Dashboard>(`${baseUrl}/`, { method: 'POST', body: JSON.stringify(payload) });
    }
}

export async function deleteDashboard (dashboardId: string) {
    return await APIClient(`${baseUrl}/${dashboardId}`, { method: 'DELETE' });
}

export async function updateDashboardDetail (data: Partial<Dashboard>) {
    delete data.widgets;
    return await APIClient<Dashboard>(`${baseUrl}/${data.dashboardId}`, { method: 'PUT', body: JSON.stringify(data) });
}

export async function loadWidgetById (dashboardId: string, widgetId: string) {
    return await APIClient<Widget>(`${baseUrl}/${dashboardId}/widgets/${widgetId}`);
}

export async function createWidget (dashboardId: string, widget: Widget) {
    return await APIClient<Widget>(`${baseUrl}/${dashboardId}/widgets`, { method: 'POST', body: JSON.stringify(widget) });
}

export async function updateWidget (dashboardId: string, widgetData: Partial<Widget>) {
    return await APIClient<Widget>(`${baseUrl}/${dashboardId}/widgets/${widgetData.widgetId}`, { method: 'PUT', body: JSON.stringify(widgetData) });
}

export async function deleteWidget (widgetId: string, dashboardId: string) {
    return await APIClient<Widget>(`${baseUrl}/${dashboardId}/widgets/${widgetId}`, { method: 'DELETE' });
}
